import type { ReportButtonLabels } from '../../report-button-content';

export const reportButton: ReportButtonLabels = {
  report: 'Annunziar questa pagina',
  title: 'Annunziar in problem cun questa pagina',
  reasons: {
    'inaccurate-or-fabricated': 'Infurmaziuns nuncorrectas u inventadas',
    'wrong-product': 'Ils products na correspundan betg a la pagina',
    'sexually-explicit': 'Cuntegn sexualmain explicit',
    'regulated-product': 'Product cun recept obligatoric u reglà',
    'dangerous-product': 'Product privlus',
    'ip-infringement': 'Viola mes dretgs (marca/dretg d\'autur)',
    other: 'Insatge auter',
  },
  detail: 'Detagls (facultativ)',
  submit: 'Trametter l\'annunzia',
  cancel: 'Interrumper',
  sent: 'Grazia. Nus examinain las annunzias entaifer 24 uras.',
  failed: 'L\'annunzia n\'ha betg pudì vegnir tramessa. Empruvai per plaschair anc ina giada.',
};
